import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';
import PopUp from '../design-system/PopUp';
import GridCellBase from '../GridCellBase';
import PopUpContentWrapper from '../PopUpContentWrapper';
import ExpandCollapseCell from './ExpandCollapseCell';

const GLCodeDetailColumnCell = (props: GridCellProps) => {
  const setExpandedGLCode = useContextSelector(InvoiceContext, (value) => value.setExpandedGLCode);
  const hasGLChanged = useContextSelector(InvoiceContext, (value) => value.hasGLChanged);
  const { glCode } = props?.dataItem;
  const { dataItem, field = '' } = props;
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [value, setValue] = useState(dataItem[field] || false);

  useEffect(() => {
    setValue(dataItem[field] || false);
  }, [dataItem, field]);

  const handleExpandClick = useCallback(() => {
    if (!hasGLChanged) {
      const newValue = !value;
      setValue(newValue);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const newTimeoutId = setTimeout(() => {
        setExpandedGLCode((prev) => {
          if (prev.includes(glCode)) {
            const updatedItems = [...prev].filter((item: string) => item !== glCode);
            return updatedItems;
          }
          return [...prev, glCode];
        });
      }, 500);
      setTimeoutId(newTimeoutId);
    }
  }, [glCode, hasGLChanged, setExpandedGLCode, timeoutId, value]);

  const lastRow = useMemo(() => dataItem?.rowId === 'noExpand', [dataItem?.rowId]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      {!lastRow && (
        <PopUp
          content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
          show={hasGLChanged}
        >
          <ExpandCollapseCell
            expand={value}
            onExpand={handleExpandClick}
            plusIconColor={hasGLChanged ? '#aaa' : '#0e80b4'}
            minusIconColor={hasGLChanged ? '#aaa' : '#0e80b4'}
          />
        </PopUp>
      )}
    </GridCellBase>
  );
};

export default GLCodeDetailColumnCell;
